module.exports = __webpack_public_path__ + "img/becoming_a_registered_psychologist_trigger.0561f25d.jpg";